export const css = {
	root: '_2FTmB5Ba',
	loading: '_2Ow0igOU',
	titleBlock: '_1140byH1',
	title: '_3W-GxZIW',
	gotitBlock: '_2NjHpL_C',
	gotit: '_4zDiN22_',
	section: 'AHKxLqf0',
	hero: '_1A3AoxRZ',
	heroBanner: '_33gTV__R',
	heroSubtitle: 'XOMqSQeW',
	heroIconList: '_55YVmOdc',
	verticalAccordion: 'TSHzhmD5',
	accordion: 'hAr8hPZA',
	horizontalAccordion: 'Bdhl8TaD',
	storyline: '_1KaUvigD',
	xref: '_2jkMpvgw',
	HCBullet: '_1IBnV0NF',
	HCBulletStyle2: '_255BpcQd',
	TableUL: '_3GEXU1uM',
	figure: 'Pdfo6qhp',
	nextprev: '_1-_EFCud',
	next: 'UKqTMLrW',
	previous: '_3mLemmyp',
	compactyes: '_1jQMbZS9',
	' _key': 'apic-theme/apic/book-widgets/topicpage'
};

export default css;
